import React from 'react';

export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-emerald/15 py-6 bg-ivory" data-testid="marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif italic text-2xl md:text-3xl text-emerald whitespace-nowrap">{item}</span>
            <span className="h-2 w-2 rounded-full bg-terracotta shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
